import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyDBo05kB5oNmdKtHg9HQfAoGouIZKTvlbY",
  authDomain: "clone-6a965.firebaseapp.com",
  databaseURL: "https://clone-6a965.firebaseio.com",
  projectId: "clone-6a965",
  storageBucket: "clone-6a965.appspot.com",
  messagingSenderId: "474018037930",
  appId: "1:474018037930:web:967b2d1e13aea39eb010d3",
  measurementId: "G-PC26NP554C"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth };